import { fetchWithAuth } from '../utils/fetchWithAuth';

export const getAllEvents = async () => {
  try {
    const response = await fetchWithAuth('/events', {
      method: 'GET',
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const createEvent = async (eventData) => {
  try {
    const formData = new FormData();

    formData.append("title", eventData.title);
    formData.append("business_name", eventData.business_name);
    formData.append("organized_by", eventData.organized_by);
    formData.append("collaborator", eventData.collaborator || "");
    formData.append("description", eventData.description);
    formData.append("date", eventData.date);
    formData.append("hour", eventData.hour);
    formData.append("hour_end", eventData.hour_end);
    formData.append("place", eventData.place);
    formData.append("mode", eventData.mode);
    formData.append("meet_link", eventData.meet_link || "");
    formData.append("registration_link", eventData.registration_link || "");

    if (eventData.image && eventData.image.startsWith("data:image")) {
      const blob = base64ToBlob(eventData.image);
      formData.append("image", blob, "image.png");
    }

    const response = await fetchWithAuth('/events', {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error al crear el evento:", error);
    throw error;
  }
};

export const deleteEvent = async (eventId) => {
  try {
    const response = await fetchWithAuth(`/events/${eventId}`, {
      method: 'DELETE',
    });

    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    return await response;
  } catch (error) {
    console.error("Error al eliminar el evento:", error);
    throw error;
  }
};

export const updateEvent = async (eventId, eventData) => {
  try {
    const formData = new FormData();

    formData.append("title", eventData.title);
    formData.append("business_name", eventData.business_name);
    formData.append("organized_by", eventData.organized_by);
    formData.append("collaborator", eventData.collaborator || "");
    formData.append("description", eventData.description);
    formData.append("date", eventData.date);
    formData.append("hour", eventData.hour);
    formData.append("hour_end", eventData.hour_end);
    formData.append("place", eventData.place);
    formData.append("mode", eventData.mode);
    formData.append("meet_link", eventData.meet_link || "");
    formData.append("registration_link", eventData.registration_link || "");

    if (eventData.image) {
      if (typeof eventData.image !== 'string' || eventData.image.startsWith('data:')) {
        if (eventData.image.startsWith('data:')) {
          const blob = await fetch(eventData.image).then(r => r.blob());
          formData.append("image", blob, "event-image.png");
        } else if (eventData.image instanceof File) {
          formData.append("image", eventData.image, eventData.image.name);
        }
      }
    } else {
      formData.append("image", "");
    }

    const response = await fetchWithAuth(`/events/update/${eventId}`, {
      method: 'PATCH',
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP error! Status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error al actualizar el evento:", error);
    throw error;
  }
};

// Función para convertir base64 a Blob
function base64ToBlob(base64Data) {
  const matches = base64Data.match(/^data:(.+);base64,(.+)$/);
  if (!matches || matches.length !== 3) {
    throw new Error("Formato base64 no válido");
  }

  const mimeType = matches[1];
  const base64String = matches[2];

  const byteCharacters = atob(base64String);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mimeType });
}
